module.exports = __webpack_public_path__ + "img/emo_15.be1c266b.png";